import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class StripeService extends BaseService {

    static url = "checkout";
    static apis = {
        get: { path: "", method: "get" },
        createSession: { path: "checkout/stripe", method: "post" }
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("checkout");
    }

    createSession() {
        var that = this
        return new Promise((resolve, reject) => {
            that.axios({
                url: StripeService.apis.createSession.path,
                method: StripeService.apis.createSession.method,
                authorization:false,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

}

export default StripeService;